import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ivanti = defineConnector({
  identifier: "ivanti",
  name: "Ivanti",
  tagLine: "IT asset and service management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://[^/]*\\.ivanti\\.com/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: `rest_api_key=${app.secret.apiKey}` },
    ]),
  steps: [
    {
      title: "Get your Ivanti API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your Ivanti instance and navigate to **Configure > Security > API Keys** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "baseUrl",
          label: "Instance URL",
          required: true,
          placeholder: "https://yourcompany.ivanti.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The URL of your Ivanti instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/api/odata/businessobject/incidents?$top=1`,
  },
  publicEnvVars: ({ instanceUrl }) => ({
    IVANTI_URL: instanceUrl || "",
  }),
});
